import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import * as CryptoJS from 'crypto-js'
import { environment } from '../../environments/environment'
import { AlertService } from '../_services/index'
import { DataService } from '../data.service'
import { LoginService } from '../login/login.service'
import { AppService } from '../app.service'

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
})
export class ForgotPasswordComponent implements OnInit {
  model: any = {}
  btnDisable: boolean
  currentUrl: any
  redirectUrl: any
  backRedirectUrl: any
  contentInfo: any = {}
  appConstant: any = {}
  logo: any
  constructor(
    private loginService: LoginService,
    private router: Router,
    private alertService: AlertService,
    private dataService: DataService,
    private appService: AppService
  ) {}
  ngOnInit(): any {
    this.appConstant = environment
    this.appService.getInformation().subscribe((data: any) => {
      this.contentInfo = JSON.stringify(data)
      localStorage.setItem('contentInfo', this.contentInfo)
      this.dataService.changeLocalData('update data')
      if(data.website_content.backend_logo.backend_logo){
        this.logo = this.appConstant.contentImagePath + data.website_content.backend_logo.backend_logo
      }
    })

    if (this.router.url === '/brand-forgot-password') {
      this.model.userType = 'brand'
      this.redirectUrl = '/brand-reset-password'
      this.backRedirectUrl = '/brand-login'
    } else {
      this.model.userType = 'superuser'
      this.redirectUrl = '/reset-password'
      this.backRedirectUrl = '/'
    }
    this.dataService.changeProfileService({ url: this.router.url })
  }
  forGotPassword(form: any): void {
    if (form) {
      this.btnDisable = true
      this.loginService.forGotPassword(this.model).subscribe(
        (data: any) => {
          const forgotPasswordData: any = {
            forgotPasswordPublicId: data.public_id,
            email: this.model.email,
          }
          const setUserData: any = CryptoJS.AES.encrypt(
            JSON.stringify(forgotPasswordData),
            environment.secretKey
          ).toString()
          localStorage.setItem('forgotPasswordData', setUserData)
          this.alertService.success(data.message)
          this.btnDisable = false
          this.router.navigate([this.redirectUrl])
        },
        (err: any) => {
          this.btnDisable = false
          if (err.status === 400 || err.status === 401 || err.status === 404) {
            if (err.error.error) {
              this.alertService.error(err.error.error)
            } else if (err.error.email) {
              this.alertService.error(err.error.email)
            } else if (err.error.userType) {
              this.alertService.error(err.error.userType)
            }
          }
        }
      )
    }
  }
  errorHandler(event: any): void {
    event.target.src = environment.logoNoImage
  }

}
